export default __webpack_public_path__ + "static/contact-image-26558975fc7cbfc36d6921eea063f6e1.jpg";